import React, {useMemo} from "react";
import styled from "styled-components";
import Layout from "../../Shared/Layout";
import {
    Container,
} from "@material-ui/core";
import { Trans } from "../../utils/i18n";
import MuiButton from "@material-ui/core/Button";
import DeviceWidget from "../../FormComponents/DeviceWidget/DeviceWidget";
import {Inertia} from "@inertiajs/inertia";

export default function UserInteractionShow({
   order,
   hash,
   feedbacks,
}) {

    return (
        <div>
            <Container maxWidth="md">
                <div className={'bg-blue-200 rounded-lg font-bold text-center p-1.5 text-lg'}>
                    <Trans i18nKey="userInteraction.title">
                        Customer Response
                    </Trans>
                </div>

                <div className={'flex flex-col items-center gap-6 '}>
                    <div className={'w-full max-w-3xl'}>
                        <DeviceWidget values={order.installation_address} product={order.products[0]} serviceProduct={{}} problem1={order.products[0].problem1} problem2={order.products[0].problem2} />
                    </div>
                    <div className={'b2x-shadow-md rounded-lg px-6 pb-6 w-full max-w-3xl'}>
                            <p className={'font-bold'}>
                                <Trans i18nKey="userInteraction.description1">
                                    We would like to inform you that during the inspection of your device on repair request "{{ orderId: order.number }}" it was identified that it is not possible to repair your device.
                                </Trans>
                            </p>
                            <p className={''}>
                                <Trans i18nKey="userInteraction.description2">
                                    As your device is not repairable, we need you to confirm if you want us to return your device to you unrepaired, or if you want us to recycle your device for you.
                                </Trans>
                            </p>
                            <p className={''}>
                                <Trans i18nKey="userInteraction.description3">
                                    Both options have no additional cost to you.
                                </Trans>
                            </p>

                        <div className={'flex justify-between flex-wrap gap-3 items-center mt-  6'}>
                            {
                                feedbacks.map((feedback, index) => {
                                    return (
                                        <MuiButton
                                            variant={feedback.key !== 'recycle' ?"outlined" : "contained"}
                                            color={"secondary"}
                                            key={feedback.id}
                                            onClick={() => {
                                                Inertia.post(route("order.userinteraction.store", {order: order.order_id, hash, feedback: feedback.id}), {});
                                            }}
                                        >
                                            {
                                                feedback.text
                                            }
                                        </MuiButton>
                                    )
                                })
                            }
                        </div>
                    </div>
                </div>
            </Container>
        </div>
    );
}

UserInteractionShow.layout = (page) => <Layout children={page} />;
